import { GadgetPlaform } from "../pages/Home/components/gadgets/GadgetPlaform";

export interface GeneralFileFormat {
  file_extension: string;
  file_format: string;
}

export interface GadgetFileFormat {
  inputs: GeneralFileFormat[];
  outputs: GeneralFileFormat[]
}

export interface Channel {
  id: number;
  name: string
}

export interface GadgetVersion {
  name: string;
  id: number;
  description: string;
  platform: GadgetPlaform;
  snapshots: string[];
  size: number;
  channels: Channel[];
  file_formats: GadgetFileFormat;
  version: string;
  last_modified_on: string;
  icon: string;
  license: License;
}

export interface License {
  id: number,
  name: string,
  description: string
}

export interface Gadget {
  name: string;
  provider: string;
  supportedOs: string;
  id: number;
  key: string;
  licensed: boolean;
  developer_name: string;
  published_versions: GadgetVersion[];
  license: License;
}

export interface FlattenedGadget {
  name: string;
  provider: string;
  supportedOs: string;
  id: number;
  key: string;
  licensed: boolean;
  developer_name: string;
  description: string;
  platform: GadgetPlaform;
  snapshots: string[];
  size: number;
  channels: Channel[];
  file_formats: GadgetFileFormat;
  version: string;
  lastModifiedOn: string;
  icon: string;
  license: License;
}

const defauultLicense: License = {
  id: 0,
  name: "Garuda Freeware License",
  description: "Garuda Freeware License"
}

export const getFlattenedGadget = (gadget: Gadget) => {
  const publishedVersion = gadget.published_versions[0];
  return {
    name: gadget.name,
    provider: gadget.provider,
    supportedOs: publishedVersion.platform,
    id: gadget.id,
    key: gadget.key,
    licensed: gadget.licensed,
    developer_name: gadget.developer_name,
    description: publishedVersion.description,
    platform: publishedVersion.platform,
    snapshots: publishedVersion.snapshots,
    size: publishedVersion.size,
    channels: publishedVersion.channels,
    file_formats: publishedVersion.file_formats,
    version: publishedVersion.version,
    lastModifiedOn: publishedVersion.last_modified_on,
    icon: publishedVersion.icon,
    license: publishedVersion.license ? publishedVersion.license : defauultLicense
  } as FlattenedGadget
}

export const SESSION_STORAGE_KEY = "garudaSession";